import { styled } from "styled-components";
import { padding } from "polished";
const DropdownMenuSectionWrapper = styled.div({});
const DropdownMenuSectionHeading = styled("h4")(
  ({ theme }) => ({
    color: theme.color.gray7,
    fontWeight: theme.fontWeight.semiBold,
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize.sm,
    lineHeight: theme.lineHeight.sm,
    margin: 0,
    ...padding(4, 8),
    textTransform: "uppercase"
  }),
  ({ $magnitude }) => ({
    small: {
      ...padding(2, null)
    },
    medium: {
      ...padding(4, null)
    },
    large: {
      ...padding(6, null)
    }
  })[$magnitude]
);
export {
  DropdownMenuSectionHeading,
  DropdownMenuSectionWrapper
};
